import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "c-eyecatch c-eyecatch--mail-permission" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-eyecatch__img" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mypage__ttl c-ttl" }, "メール受信設定", -1)
const _hoisted_3 = { class: "p-mypage__sec" }
const _hoisted_4 = { class: "p-mypage__field-container" }
const _hoisted_5 = { class: "p-errors" }
const _hoisted_6 = { class: "c-error" }
const _hoisted_7 = { class: "p-fields" }
const _hoisted_8 = { class: "c-field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "集英社IDからのお知らせ", -1)
const _hoisted_10 = { class: "c-field__body" }
const _hoisted_11 = { class: "c-field__radio" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "approved" }, "受信する", -1)
const _hoisted_13 = { class: "c-field__radio" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "denied" }, "受信しない", -1)
const _hoisted_15 = { class: "c-field has-submit has-mt" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "入力内容を確認する", -1)
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "戻る", -1)
const _hoisted_20 = [
  _hoisted_19
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.update,
        "validation-schema": _ctx.schema,
        ref: "formRef"
      }, {
        default: _withCtx(({ errors, meta }) => [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.errorMsgRef), 1)
            ], 512), [
              [_vShow, _ctx.errorMsgRef]
            ]),
            _createElementVNode("fieldset", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Field, {
                      type: "radio",
                      id: "approved",
                      name: "sidAll",
                      value: true,
                      modelValue: _ctx.userMailPermission.mailPermissionInfo.sidAll,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userMailPermission.mailPermissionInfo.sidAll) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_12
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_Field, {
                      type: "radio",
                      id: "denied",
                      name: "sidAll",
                      value: false,
                      modelValue: _ctx.userMailPermission.mailPermissionInfo.sidAll,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userMailPermission.mailPermissionInfo.sidAll) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_14
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.sidAll), 513), [
                [_vShow, errors.sidAll]
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "c-btn is-submit",
                  disabled: !meta.valid
                }, _hoisted_18, 8, _hoisted_16),
                _createElementVNode("button", {
                  type: "button",
                  class: "c-btn c-btn--outline",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push({ name: 'MypageTop' })))
                }, _hoisted_20)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ], 64))
}